import clsx from 'clsx';
import React, { useEffect } from 'react';

export default function MarketingLeadCaptureWithGoogle({
  eventName,
  verificationUri,
  leadType,
  returningUri,
  fullWidth = false,
}: {
  eventName: string;
  fullWidth?: boolean;
  leadType: string;
  returningUri?: string;
  verificationUri: string;
}) {
  useEffect(() => {
    window['gapi'].signin2.render('g-signin2', {
      onsuccess: eventName,
      theme: 'dark',
      height: '48',
      width: '250',
      longtitle: 'true',
      verificationUri: verificationUri,
      leadType: leadType,
      returningUri: returningUri,
    });
  }, [eventName, verificationUri, leadType, returningUri]);

  return (
    <div className={clsx({ 'g-signin2-fullwidth': fullWidth })}>
      <div
        id="g-signin2"
        data-onsuccess={eventName}
        data-verification-uri={verificationUri}
        data-lead-type={leadType}
        data-returning-uri={returningUri}
      />
    </div>
  );
}
